const API_BASE_URL = import.meta.env.VITE_API_BASE_URL;

async function postAuth(path, body) {
  const response = await fetch(`${API_BASE_URL}${path}`, {
    method: "POST",
    headers: { "Content-Type": "application/json" },
    credentials: "include",
    body: JSON.stringify(body),
  });

  let data = {};
  try {
    data = await response.json();
  } catch {
    data = {};
  }

  return {
    ok: response.ok,
    status: response.status,
    data,
  };
}

export async function signup({ email, password }) {
  return postAuth("/auth/signup", { email, password });
}

export async function confirmSignup({ email, code }) {
  return postAuth("/auth/confirm", { email, code });
}

export async function resendConfirmation({ email }) {
  return postAuth("/auth/resend-confirmation", { email });
}

export async function login({ email, password }) {
  return postAuth("/auth/login", { email, password });
}

/** Cognito password rules mirrored for client-side hints. */
export const PASSWORD_HINT =
  "Mínimo 8 caracteres, com maiúscula, minúscula, número e caractere especial.";

export function validatePasswordClient(password) {
  if (!password || password.length < 8) {
    return "A senha deve ter no mínimo 8 caracteres.";
  }
  if (!/[A-Z]/.test(password)) return "A senha deve conter letra maiúscula.";
  if (!/[a-z]/.test(password)) return "A senha deve conter letra minúscula.";
  if (!/\d/.test(password)) return "A senha deve conter número.";
  if (!/[^A-Za-z0-9]/.test(password)) {
    return "A senha deve conter caractere especial.";
  }
  return null;
}
